// Route colours are display data, rather than a direct pass-through of GTFS
// values. Keeping this small normaliser independent lets every map and trip
// surface make the same decision.
export function normalizeRouteColor(
  color,
  routeType,
  routeLabel,
  { nightRouteColor } = {},
) {
  if (nightRouteColor && routeLabel?.startsWith("N")) {
    return nightRouteColor;
  }

  if (Number(routeType) === 712) {
    return "#FFEE00";
  }

  if (color === "000000") {
    return "#222B2D";
  }

  return color?.startsWith("#") ? color : `#${color || "222B2D"}`;
}
